import { useCachedDataProvider } from '@ragu-components/ord-providers';

import type { IngordDataProvider } from 'src/lib/types';

/**
 * Custom hook that provides data management functionality for Ingord components.
 *
 * This hook utilizes the cached data provider hook with specific typing for IngordDataProvider.
 *
 * @returns A cached data provider instance with Ingord-specific operations
 */
export const useIngordDataProvider = useCachedDataProvider<IngordDataProvider>;
